


























































































import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
import { ScrappedTypeServiceProxy } from "@/service-proxies/app-v2/qc.service-proxies";
import Vue from "vue";
const csp = new CodeRuleServiceProxy();
const scrappedTypeServiceProxy = new ScrappedTypeServiceProxy();
export default Vue.extend({
  name: "AddorEditScrapType",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    addType: {
      type: Boolean,
      default: false,
    },
    deviceTypeId: {
      type: String,
      default: "",
    },
    editForm: {
      type: Object,
    },
    apply: {
      type: Object,
    },
  },
  data() {
    return {
      scrappedCodeIdList: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        codeRuleId: "",
        code: "",
        name: "",
        remark: "",
      },
      codeDisabled: false,
      rules: {
        code: [
          { required: true, message: this.$t('page_write_scraptype_code'),},
        ],
        name: [{required: true, max: 128, message: this.$t('page_max_32_code'), trigger: 'change' }],
        remark: [{max: 128, message: this.$t('page_max_256_code'), trigger: 'change' }],
      },
      saveLoading: false
    };
  },
  computed: {
    title () {
      return  this.addType ? this.$t('create'): this.$t("edit")
    }
  },
  created() {
    csp.list("ScrappedTypeObject").then((res) => {
      this.scrappedCodeIdList = res;
    });
  },
  watch: {
    'form.codeRuleId': {
      handler(val) {
        console.log('val', val)
        this.rules.code[0].required = !val
        this.codeDisabled = !!val
        if (val) {
          this.form.code = ''
        }
      },
      deep: true,
      immediate: true
    },
    editForm (val) {
      console.log('22', val)
      if (val) {
        this.form = val
      }
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    changeRuleScrap($event) {
      this.form.codeRuleId = $event
      // this.form.code = ''
    },
    handleOk() {
      this.saveLoading = true
      console.log('111', this.$refs.ruleForm)
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.addType) {
            scrappedTypeServiceProxy.saveScrappedType(this.form).then(res => {
              this.$emit('cancel', true)
              this.saveLoading = false
            }).catch(() => {
              this.saveLoading = false
            })
          } else {
            scrappedTypeServiceProxy.updateScrappedType(this.form).then(res => {
              this.$emit('cancel', true)
              this.saveLoading = false
            }).catch(() => {
              this.saveLoading = false
            })
          }
        } else {
          this.saveLoading = false
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleCancel() {
      this.reset()
      this.$emit('cancel', false)
    },
    reset () {
      this.form = {
        codeRuleId: "",
        code: "",
        name: "",
        remark: "",
      }
    }
  }, 
});
